import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/homePage'
import Formula from '@/pages/home/formula'
import WxAuth from '@/pages/home/wxAuth'
import { pageCategory } from './../utils/pageCategory'
import Layout from '@/pages/layout/layout.vue'
import sa from 'sa-sdk-javascript'
import encode from '../utils/encode'

Vue.use(Router)
const ua = navigator.userAgent.toLowerCase()
var isApp = ua.indexOf('tool') > -1&&ua.indexOf('micromessenger') < 0
var isYsz = ua.indexOf('ysz') > -1
var isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1
var isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
// 递归获取 pages/formulas 文件夹下的所有.vue文件
const files = require.context('@/pages/formulas', true, /\.vue$/)
let pages = {}
files.keys().forEach(key => {
  pages[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
})

// 生成路由规则
let formulasRouter = []
let generator = []
const context = require.context('@/pages/formulas', true, /\.vue$/)
const install = () => {
  context.keys().forEach((key) => {
    const component = context(key).default
    // Vue.component(component.name, component);
    generator.push({
      path: `/${component.name.replace(/-/g, '/')}`,
      name: component.name,
      component: component,
      meta: {
        title: pageCategory[component.name],
        buriedTitle: pageCategory[component.name] + '-埋点'
      }
    })
  })
  formulasRouter.push({
    path: '/',
    name: 'Layout',
    title: 'Layout',
    component: Layout,
    redirect: '/home',
    children: generator
  })
}
install()

function asyncRoutes () {
  const router = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      buriedTitle: '首页-首页'
    }
  },
  {
    path: '/formula',
    name: 'Formula',
    component: Formula,
    meta: {
      title: '公式',
      buriedTitle: '公式'
    }
  },
  ...formulasRouter

  ]
  return router
}
// 基础路由
function constRoutes () {
  // 基础router
  const router = [{
    path: '/wxAuth',
    name: 'WxAuth',
    component: WxAuth,
    meta: {
      title: '授权',
      buriedTitle: '授权页面'
    }
  },

  {
    path: '/delete',
    name: 'Delete',
    component: () =>
                import('@/pages/delete/delete.vue'),
    meta: {
      title: '缺省页面'
    }
  },
  {
    path: '/oldformula',
    name: 'OldFormula',
    component: () =>
                import('@/pages/oldformula/oldformula.vue'),
    meta: {
      title: '医学公式'
    }
  }
  ]
  return router
}

// router对象工厂
function routerFactory () {
  let routers = constRoutes()
  let custormRouters = asyncRoutes()
  // 合并两个数组
  if (custormRouters) {
    routers = routers.concat(custormRouters)
  }
  const routerObj = new Router({ routes: routers })
  // 加上await 保证在发请求之前拿到的token是最新的
  routerObj.beforeEach(async (to, form, next) => {
    if (isApp) {
      await getToken().then((result) => {
        let token = result.token
        localStorage.setItem('token', token)
        if (token) {
          sa.registerPage({
            tool_isAnonymousVisitor: false
          })
        } else {
          sa.registerPage({
            tool_isAnonymousVisitor: true
          })
        }
      }).catch(err => {
        console.log(err)
      })
      next()
    } else if (isYsz) {
      console.log('isYsz');
      if (isAndroid) {
        let userInfo = {}
        userInfo.uid = getUidAndroid()
        userInfo.session = getSession()
        userInfo.guid = getGUID()
        userInfo.version = getVersion()
        userInfo.platform = 'Android'
        console.log('userInfoYsz', userInfo)
        localStorage.setItem('YszAppInfo', JSON.stringify(userInfo))
        localStorage.setItem('token', userInfo.session)
        next()
      } else if (isIOS) {
        console.log('isYsz_isIOS');
        AppBaseInfoSave(iosUserInfoCacllBackNotNeedLogin)
        getAppBaseInfo()
      }
      next()
    } else {
      next()
    }
  })

  return routerObj
}

/** ios  回调的函数 APP不需要登陆的 */
function iosUserInfoCacllBackNotNeedLogin (obj, cb) {
  console.log(obj)
  console.log(new Date().getTime(), 'ios 返回时间')
  let iosCallbackInfo = decodeURIComponent(obj)
  let localInfo = JSON.parse(encode.decodeFuc(iosCallbackInfo))
  localStorage.setItem('token', localInfo.session)
  localStorage.setItem('YszAppInfo', JSON.stringify(localInfo))
  console.log(localInfo, 'ios 回调的用户信息55555')
  cb()
}
export default routerFactory()



// WEBPACK FOOTER //
// ./src/router/index.js